import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import SignInLocationState from "@/model/SignInLocationState";

/** Sends anonymous visitors to sign in, then back to the page they wanted. */
function RequireAuth() {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return null;
  }

  if (!isAuthenticated) {
    const state: SignInLocationState = { from: `${location.pathname}${location.search}` };
    return <Navigate to="/signin" replace state={state} />;
  }

  return <Outlet />;
}

export default RequireAuth;
